// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { signInCreateNewAccountStyles } from "@west/Overrides/Widgets/SignIn/SignInCreateNewAccount";
import { mergeWithCss, xScreen } from "@west/XDL/Utilities";
import { css } from "styled-components";

signInCreateNewAccountStyles.signInCreateNewAccountTitle = {
    forwardAs: "h4",
    variant: "h2",
    css: css`
        margin-bottom: 10px;
    `,
};

signInCreateNewAccountStyles.signInCreateNewAccountImageGridItem = {
    width: 12,
    css: css`
        img {
            max-height: 80px;
            max-width: 207px;
        }
    `,
};

signInCreateNewAccountStyles.signInCreateNewAccountText = {
    css: css`
        &,
        & > ${TypographyStyle} {
            font-size: 14px;
            font-weight: normal;
        }
    `,
};

signInCreateNewAccountStyles.createNewAccountButton = {
    variant: "tertiary",
};
signInCreateNewAccountStyles.signInCreateNewAccountButtonGridItem = {
    width: 12,
    css: css`
        ${({ isMiniSignIn }: any) =>
            css`
                flex-direction: ${isMiniSignIn ? "column" : "row"};
            `}

        ${xScreen("lte", "sm")} {
            flex-direction: column;
        }
    `,
};

signInCreateNewAccountStyles.checkoutAsGuestButton = {
    ...mergeWithCss(signInCreateNewAccountStyles.checkoutAsGuestButton, {
        css: css`
            margin-right: 16px;
        `,
    }),
};
